// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';
import {
  Action,
  Divider,
  ListItem,
  ListRow,
  TitleCell,
} from '@gandi/ui/deprecated';
import type { TranslatorProps } from '@gandi/translate';

type Props = {|
  title: string,
  translator: TranslatorProps,
|};

const DocumentationLinks = (props: Props): React.Element<typeof Base> => {
  const { __ } = props.translator;

  return (
    <Base marginBottom="base">
      <ListRow separatorBottom>
        <ListItem>
          <TitleCell>{props.title}</TitleCell>
        </ListItem>
      </ListRow>
      <Divider separatorBottom direction="columnToRow" spread="equal">
        <Action
          icon="domainWire"
          href={__('https://docs.gandi.net/en/domain_names/index.html')}
          variant="block"
        >
          {__('Domain')}
        </Action>
        <Action
          icon="envelopeDouble"
          href={__('https://docs.gandi.net/en/gandimail/index.html')}
          variant="block"
        >
          {__('Email')}
        </Action>
        <Action
          icon="certificatesWire"
          href={__('https://docs.gandi.net/en/ssl/index.html')}
          variant="block"
        >
          {__('SSL Certificates')}
        </Action>
      </Divider>
      <Divider direction="columnToRow" spread="equal">
        <Action
          icon="simplehostingWire"
          href={__('https://docs.gandi.net/en/simple_hosting/index.html')}
          variant="block"
        >
          {__('Web Hosting')}
        </Action>
        <Action
          icon="gostackWire"
          href={__('https://docs.gandi.net/en/cloud/vps/index.html')}
          variant="block"
        >
          {__('GandiCloud VPS')}
        </Action>
        <Action
          icon="arrowRight"
          href={__('https://docs.gandi.net/en')}
          variant="block"
        >
          {__('All Topics')}
        </Action>
      </Divider>
    </Base>
  );
};

export default DocumentationLinks;
